/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function(){
   function append_in_summary(){
     if($('.gf-summary').length > 0){
        $('.gf-summary').append('<div class="top_bar_collection" style="display: none;">Previously applied filters and sort options are active. To remove them <a href="'+ current_canonical_url +'">click here</a></div>');
        $('.top_bar_collection').slideDown();
     }else{
       setTimeout(function(){
         append_in_summary();
       },1000);
     }
   }
    // if(need_to_show_banner == 1){
    //   append_in_summary();
    // }
   $('body').on('click', '.top_bar_collection a',function(e){
     e.preventDefault();
     localStorage.setItem("filter_set", '');
     window.location = $(this).attr('href');
   });
    $('body').on('keyup', '.is_gift_wrap_msg',function(e){
      e.preventDefault();
      $('.limit_text').remove();
      var pending = 300 - $(this).val().length;
      $('.gift_note_wrp').append('<div class="limit_text">'+ pending + ' character(s) left </div>');
    });
    $('body').on('change', '.is_gift_wrap_msg',function(e){
      e.preventDefault();
      var val = $(this).val();
      $.ajax({
          url: "".concat(window.routes.cartUrl, "/update.js"),
          type: 'POST',
          data: {"attributes[gift-message-note]": val},
          success: function(result) { 
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
          },
          error: function(jqxhr, status, exception) {
              console.log(exception);
          }
      });
    });
    $('body').on('change','input[name="set_gift_wrap"]',function(e){
      e.preventDefault();
      var var_input = Number($(this).attr('data-variant_id'));
      if(typeof var_input !== 'undefined' && var_input != null && var_input != ''){
        if($(this).is(':checked')){
          if(!$('.CartItem[data-variant_id="'+ var_input +'"]').length){
            var data = [];
            var items = {};
            items.id = var_input;
            items.quantity = 1;
            data.push(items);
            $.post("".concat(window.routes.cartAddUrl, ".js"), {
              items: data
            }, function(c){
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
            },'JSON').fail(function(response) {
              console.log('In error');
            });
          }
        }else if($('.CartItem[data-variant_id="'+ var_input +'"]').length){
          var cline = $('.CartItem[data-variant_id="'+ var_input +'"]').attr('data-line');
          var cdata = {
            line: cline,
            quantity: 0,
          }; 
          fetch("".concat(window.routes.cartChangeUrl, ".js"), {
            method: 'post',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(cdata),
          }).then(data => {
            $.ajax({
                url: "".concat(window.routes.cartUrl, "/update.js"),
                type: 'POST',
                data: {"attributes[gift-message-note]": ""},
                success: function(result) { 
                    console.log('done');
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
                },
                error: function(jqxhr, status, exception) {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
                }
            });
          })
        }
      }
    });

     setInterval(function(){
       $('body .slidecarthq .price, body .slidecarthq .upsell-text-prices p, body .slidecarthq .slidecart-subtotal, body .slidecarthq .compare-at').addClass('money');
     },500); 
      window.SLIDECART_UPDATED = function(cart) {
        $('.slidecarthq .item').each(function(hi,hv){
          $('body .slidecarthq .price, body .slidecarthq .upsell-text-prices p, body .slidecarthq .slidecart-subtotal, body .slidecarthq .compare-at').removeClass('done');
        });
        var countfix = cart.item_count;
        document.querySelector('.header__cart-dot').innerHTML = countfix;
      }
      
  });

// collection custom atc function
async function customAddProductToCart(event, element) {
  event.preventDefault();

  let variantSelector = element.closest('.ProductItem__Wrapper').querySelector('.product-select-new .variants-options');

  if (parseInt(variantSelector.value) === 0) {
    variantSelector.classList.add('invalidSelection');
    return;
  }

  variantSelector.classList.remove('invalidSelection');

  element.setAttribute('var_id', variantSelector.value);
  let variantId = element.getAttribute('var_id');

  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:prepare-bundled-sections", {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    })
  );

  let data = {
    quantity: 1,
    id: variantId,
    sections: sectionsToBundle.join(",")
  };

  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

  try {
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(data)
    });

    if (!addResponse.ok) {
      let errorMessage = `Add to cart failed: ${addResponse.status}`;

      try {
        const errorData = await addResponse.json();
        if (errorData && errorData.description) {
          errorMessage = errorData.description;
        } else if (errorData && errorData.message) {
          errorMessage = errorData.message;
        }
      } catch (err) {
        const errorText = await addResponse.text();
        if (errorText) {
          errorMessage = errorText;
        }
      }

      throw new Error(errorMessage);
    }
    const productData = await addResponse.json();
    const cartResponse = await fetch(`${Shopify.routes.root}cart.js`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!cartResponse.ok) {
      let errorMessage = `Cart fetch failed: ${cartResponse.status}`;
      try {
        const errorData = await cartResponse.json();
        if (errorData && errorData.message) {
          errorMessage = errorData.message;
        }
      } catch (err) {
        const errorText = await cartResponse.text();
        if (errorText) {
          errorMessage = errorText;
        }
      }
      throw new Error(errorMessage);
    }

    const cartContent = await cartResponse.json();
    cartContent["sections"] = productData["sections"];
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));

    document.documentElement.dispatchEvent(new CustomEvent("variant:add", {
      bubbles: true,
      detail: {
        items: productData.hasOwnProperty("items") ? productData["items"] : [productData],
        cart: cartContent,
        onSuccessDo: null
      }
    }));

    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "variant:add",
        onSuccessDo: null,
        cart: cartContent
      }
    }));

  } catch (error) {
    console.error('Error in customAddProductToCart:', error.message);
  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    const productCard = element.closest(".ProductItem__Wrapper");
    if (productCard) {
      const targetContainer = productCard.querySelector(".custom-add-to-cart-wrapper");
      if (targetContainer) {
        const existingBanner = targetContainer.querySelector(".banner--error");
        if (existingBanner) existingBanner.remove();
        const bannerElement = document.createRange().createContextualFragment(`
          <div class="banner banner--error" role="alert">
            ${error.message}
          </div>
        `).firstElementChild;
        targetContainer.appendChild(bannerElement);

        setTimeout(() => {
          bannerElement.remove();
        }, 2500);
      }
    }
  }
}
